module.exports = __webpack_public_path__ + "static/soc2-ceebd559670670dd1dae2c086742e7d5.png";